import { usingGet, usingUpload, usingPost, createProxyUrl, usingDelete } from '@ocean/api'
import { SessionUtils } from '@ocean/utils'
import { UserUtils } from 'utils'

export const getDistanceCourseDetails = (distanceCourseId: Guid, resultId?: Guid) => {
  const baseUrl = `DistanceCourses/Details/${distanceCourseId}`
  const url = resultId ? `${baseUrl}/${resultId}` : baseUrl
  return usingGet(url, { useProxy: true })
}

export const uploadDistanceCourseDocument = (
  files: File[],
  requirementId: Guid,
  inProgressResultId?: Guid
) => {
  const { login: userId } = UserUtils.getUserAccountInfo()
  const input = {
    requirementId,
    resultId: inProgressResultId,
    userId,
  }
  const formData = new FormData()
  formData.append('BinaryMetadata', JSON.stringify(input))
  formData.append('BinaryData', files[0])
  return usingUpload('DistanceCourses/UploadDistanceCourseDocument', formData)
}

export const removeDistanceCourseDocument = (requirementId: Guid, inProgressResultId?: Guid) =>
  usingDelete(`DistanceCourses/DeleteDistanceCourseResultDocument`, {
    requirementId: requirementId,
    resultId: inProgressResultId,
  })

export const createDistanceCourseResult = (distanceCourseId: Guid) => {
  const { login: userId } = UserUtils.getUserAccountInfo()
  const input = {
    courseId: distanceCourseId,
    userId,
    forceNew: true,
  }
  return usingPost('DistanceCourses/CreateDistanceCourseResult', input)
}

export const submitDistanceCourseResult = (resultId: Guid) =>
  usingPost('DistanceCourses/SubmitDistanceCourseResult', { resultId })

export const createCertificateDownloadUrl = (documentId: Guid) => {
  const sessionToken = SessionUtils.getSessionToken() || ''
  return createProxyUrl(
    `DistanceCourses/GetDistanceCourseResultCertificate?token=${sessionToken}&id=${documentId}`
  )
}

export const createDocumentDownloadUrl = (requirementId: Guid, inProgressResultId: Guid) => {
  const sessionToken = SessionUtils.getSessionToken() || ''
  return createProxyUrl(
    `DistanceCourses/getResultDocument?token=${sessionToken}&requirementId=${requirementId}&resultId=${inProgressResultId}`
  )
}
